import { render, staticRenderFns } from "./chatDialog.vue?vue&type=template&id=4c554b80&"
import script from "./chatDialog.vue?vue&type=script&lang=js&"
export * from "./chatDialog.vue?vue&type=script&lang=js&"
import style0 from "./chatDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c554b80')) {
      api.createRecord('4c554b80', component.options)
    } else {
      api.reload('4c554b80', component.options)
    }
    module.hot.accept("./chatDialog.vue?vue&type=template&id=4c554b80&", function () {
      api.rerender('4c554b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/CargoIm/chatDialog.vue"
export default component.exports